import ProposalHeader from './ProposalWixHeaderBar';

export default ProposalHeader;
